import React from "react";
import PropTypes from "prop-types";
import "./articleTags.scss";
import Pill from "../pill/pill";
import { PILL_TYPE } from "../pill/pill.constant";

const ArticleTags = ({ tags, sectionId, source, flow }) => {
  return (
    <div className="article-tags">
      <span className="title">Related Tags</span>
      <div className="article-tags-list">
        {tags.map(tag => (
          <Pill
            key={tag.id}
            data={tag}
            pillType={PILL_TYPE.TAG}
            sectionId={sectionId}
            source={source}
            flow={flow}
          />
        ))}
      </div>
    </div>
  );
};

ArticleTags.propTypes = {
  tags: PropTypes.array,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default ArticleTags;
